<template>
    <div>
        <template v-if="convertPrice">
            {{ $filters.price(price) }}
        </template>
        <template v-else>
            {{ $filters.priceFormat(price.amount, price.currency) }}
        </template>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class PriceLabel extends Vue {
        @Prop({required: true}) price
        @Prop({default: false, type: Boolean}) convertPrice
    }

    export default PriceLabel
</script>
